import { locale as currentLocale, type LocaleCode } from '@/i18n'

/* Language switcher — NEW FEATURE, not present in the original app (the
 * original had no localization at all). Deliberately additive: a small
 * fixed pill in the TOP-LEFT corner, the only corner free on both live
 * screens (Tracking's top-right holds the recenter FAB, the bottom holds
 * the sheet). Styled after the version badge: white, 1px primary border,
 * radius 12; active segment filled primary.
 *
 * pointer-events only on the pill itself — map gestures around it pass
 * through untouched. */

const LOCALES: LocaleCode[] = ['en', 'da']

export function LocaleSwitcher({
  current,
  onChange,
}: {
  current: LocaleCode
  onChange: (code: LocaleCode) => void
}) {
  void currentLocale // (import keeps the module's live binding in scope)
  return (
    <div
      role="group"
      aria-label="Language"
      data-locale-switcher
      style={{
        position: 'fixed',
        top: 'calc(16px + env(safe-area-inset-top, 0px))',
        left: 16,
        zIndex: 900, // above the map, below toasts (1000)
        display: 'flex',
        background: 'var(--secondary-background)',
        border: '1px solid var(--primary)',
        borderRadius: 12,
        boxShadow: '0 2px 4px var(--badge-shadow)',
        overflow: 'hidden',
        pointerEvents: 'auto',
      }}
    >
      {LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          data-locale-option={code}
          aria-pressed={current === code}
          onClick={() => {
            if (current !== code) onChange(code)
          }}
          style={{
            padding: '5px 10px',
            fontFamily: 'var(--font-poppins-regular)',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: 1,
            letterSpacing: 0.5,
            color: current === code ? '#ffffff' : 'var(--primary-text)',
            background: current === code ? 'var(--primary)' : 'transparent',
            cursor: 'pointer',
          }}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
